<template>
  <span v-html="content" class="text-highlight" :class="{ 'is-plain': isPlain }"></span>
</template>

<script>
export default {
  name: 'TextHighlight',
  props: {
    content: {
      type: String,
      required: false,
    },
    isPlain: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.text-highlight {
  mark {
    background-color: $color-accent-200;
    color: $color-normal;
    border-radius: $border-radius-small;
  }

  &.is-plain {
    mark {
      background-color: unset;
      color: unset;
    }
  }
}
</style>
